import { gsap } from './gsap'

/**
 * Marquee infinito movido desde el ticker de GSAP (no keyframes CSS),
 * para poder acelerarlo con la velocidad del scroll, invertir el sentido
 * y arrastrarlo con inercia.
 */
export class Marquee {
  constructor(track, direction = -1, speed = 60) {
    this.track = track
    this.direction = direction
    this.speed = speed
    this.x = 0
    this.renderedX = NaN
    this.setWidth = 0
    this.inertia = 0
  }

  resize(setWidth) {
    this.setWidth = setWidth
    this.renderedX = NaN
    this.render()
  }

  // Arrastre manual (px).
  nudge(dx) {
    this.x += dx
    this.render()
  }

  // Al soltar: sigue con la velocidad del gesto (px/s) y frena sola.
  release(velocity) {
    this.inertia = velocity
  }

  tick(dt, sense = 1, boost = 0, multiplier = 1) {
    let dx = this.direction * sense * (this.speed * multiplier + boost) * dt
    if (this.inertia) {
      dx += this.inertia * dt
      this.inertia *= Math.pow(0.04, dt)
      if (Math.abs(this.inertia) < 1) this.inertia = 0
    }
    if (!dx) return
    this.x += dx
    this.render()
  }

  render() {
    if (!this.setWidth) return
    const x = Math.round(gsap.utils.wrap(-this.setWidth, 0, this.x) * 100) / 100
    if (x === this.renderedX) return
    this.renderedX = x
    this.track.style.transform = `translate3d(${x}px, 0, 0)`
  }
}
